// extracted by mini-css-extract-plugin
export default {"table":"Table_table__fLgLU"};